import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import '../../../../utils/observable.extensions';
import { SidebarNavViewModel } from './sidebar-nav-view-model';
import { BaseComponent } from '../../../../models/base/base-component';
import { Viewable } from '@mobilefirstdev/base-angular';

@Component({
  selector: 'app-sidebar-navigation',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: ['./sidebar-nav.component.scss'],
  providers: [SidebarNavViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SidebarNavComponent extends BaseComponent implements OnInit, Viewable {
  constructor(public viewModel: SidebarNavViewModel) {
    super();
  }
}
